import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Defaults } from 'app/lib/constants';
import { Snackbar, SnackbarMessage } from 'app/components/core/Snackbar';

export function GenericNotification({
    id,
    onDismiss,
    message = null,
    i18nKey = null,
    i18nParams = Defaults.OBJECT
}) {
    const { t } = useTranslation();
    const resolvedMessage = i18nKey ? t(i18nKey, i18nParams) : message;

    return (
        <Snackbar id={id} onDismiss={onDismiss} autoHideEnabled>
            <SnackbarMessage>{resolvedMessage}</SnackbarMessage>
        </Snackbar>
    );
}

GenericNotification.propTypes = {
    id: PropTypes.string.isRequired,
    onDismiss: PropTypes.func.isRequired,
    message: PropTypes.string,
    i18nKey: PropTypes.string,
    i18nParams: PropTypes.shape({})
};
